import { useQuery } from '@tanstack/react-query';

import { $api } from 'modules/global';

import { ISavedTest } from '../models';
import { savedConst } from '..';

export const useSavedTests = () =>
  useQuery<ISavedTest[]>({
    queryKey: [savedConst.queryKeys.USE_SAVED_TESTS],
    queryFn: async () => {
      const { data } = await $api.get('/savedtest');

      return data;
    }
  });
